import { render, staticRenderFns } from "./AprobarPlan.vue?vue&type=template&id=67391274"
import script from "./AprobarPlan.vue?vue&type=script&lang=js"
export * from "./AprobarPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports